import HubDbasQuestionnairePage from './HubDbasQuestionnairePage'

export default HubDbasQuestionnairePage
